// @flow
import * as React from 'react';
import styled from 'styled-components';
import theme from 'styled-theming';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Typography from '../Common/Typography';

const color = theme('mode', {
  light: '#dc3545',
  dark: '#cc0000'
});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
`;

const StyledIcon = styled(FontAwesomeIcon)`
  color: ${color};
`;

type Props = {
  errors?: Array<string>
};

const NetworkErrorPage = (props: Props) => (
  <Container>
    <StyledIcon icon="exclamation-circle" size="4x" />
    <Typography kind="h1">Server Unavailable</Typography>
    <p>The server could not be reached, please try again later.</p>
    {props.errors.map((error, index) => (
      <div key={index}>{error}</div>
    ))}
  </Container>
);

NetworkErrorPage.defaultProps = {
  errors: []
};

export default React.memo<Props>(NetworkErrorPage);
